/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFacilityRegionRequest
 */
export interface UpdateFacilityRegionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilityRegionRequest
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFacilityRegionRequest
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the UpdateFacilityRegionRequest interface.
 */
export function instanceOfUpdateFacilityRegionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_ids" in value;

    return isInstance;
}

export function UpdateFacilityRegionRequestFromJSON(json: any): UpdateFacilityRegionRequest {
    return UpdateFacilityRegionRequestFromJSONTyped(json, false);
}

export function UpdateFacilityRegionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityRegionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function UpdateFacilityRegionRequestToJSON(value?: UpdateFacilityRegionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'facility_ids': value.facility_ids,
    };
}

